const initialState = {
    generals: [],
    loading: false,
    detailLoading: false,
    formLoading: false,
    statusLoading: false,
    error: null,
};

export default function generalReducer(state = initialState, action) {
    switch (action.type) {
        case 'GENERAL_POST_REQUEST':
            return { ...state, formLoading: true, error: null };
        case 'GENERAL_POST_SUCCESS':
            return { ...state, formLoading: false, result: action.payload };
        case 'GENERAL_POST_FAILURE':
            return { ...state, formLoading: false, error: action.error };

        case 'GENERAL_PUT_REQUEST':
            return { ...state, formLoading: true, error: null };
        case 'GENERAL_PUT_SUCCESS':
            return { ...state, formLoading: false, result: action.payload };
        case 'GENERAL_PUT_FAILURE':
            return { ...state, formLoading: false, error: action.error };


        case 'GET_TASK_LOADING':
            return { ...state, loading: true, error: null };
        case 'GET_TASK_SUCCESS':  
            return { ...state, loading: false, generals: action.payload };
        case 'GET_TASK_FAILURE':
            return { ...state, loading: false, error: action.error };    

        case 'GENERAL_GETBYID_REQUEST':
            return { ...state, detailLoading: true, error: null };
        case 'GENERAL_GETBYID_SUCCESS':
            return { ...state, detailLoading: false, result: action.payload };
        case 'GENERAL_GETBYID_FAILURE':
            return { ...state, detailLoading: false, error: action.error };
       
            
        case 'TOGGLE_STATUS_LOADING':
            return { ...state, statusLoading: true, error: null };
        case 'TOGGLE_STATUS_SUCCESS':
            return { ...state, statusLoading: false, generals: action.payload };
        case 'TOGGLE_STATUS_FAILURE':
            return { ...state, statusLoading: false, error: action.error };   

        case 'CHANGE_STATUS_LOADING':
            return { ...state, statusLoading: true, error: null };
        case 'CHANGE_STATUS_SUCCESS':
            return { ...state, statusLoading: false, generals: action.payload };
        case 'CHANGE_STATUS_FAILURE':
            return { ...state, statusLoading: false, error: action.error };      

        default:
            return state;
    }
}
